import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import NOB from '../../../../constants/language-strings';
import { PASSED } from '../../constants';
import { StatusCheck } from './status-check';
import DeviceStatus from '../../../../constants/deviceStatus';
import styled from 'styled-components';
import spacing from 'theme/spacing';
import { purpurColorFunctionalWhite, purpurColorGray100 } from '@purpurds/tokens/color/variables';
import { purpurShadowMd } from '@purpurds/tokens/shadow/variables';
const HealthCheckStatusContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: ${purpurColorFunctionalWhite};
  min-height: 65px;
  padding-left: ${spacing.spacing16};
  box-shadow: ${purpurShadowMd};
  border: 1px solid ${purpurColorGray100};
  border-top: none;
`;
export const HealthCheckHeader = ({ deviceCheck, healthCheck, isFetching, isIccFetching, isFetchingProvisioning, }) => {
    const icxCheck = healthCheck.iccCheck.deviceLinks === PASSED && healthCheck.iccCheck.devicePairing === PASSED
        ? DeviceStatus.OK
        : DeviceStatus.ERROR;
    const provisionCheck = healthCheck.provisioning.allChecksPassed
        ? DeviceStatus.OK
        : DeviceStatus.ERROR;
    return (_jsxs(HealthCheckStatusContainer, { children: [_jsx(StatusCheck, { checkTitle: NOB.HEALTH_CHECK.ICC_CHECKS, isFetching: isIccFetching, deviceStatus: icxCheck || '' }), _jsx(StatusCheck, { checkTitle: NOB.HEALTH_CHECK.PROVISIONING_STATUS, isFetching: isFetchingProvisioning, deviceStatus: provisionCheck || '' }), _jsx(StatusCheck, { checkTitle: NOB.HEALTH_CHECK.DEVICE_STATUS, isFetching: isFetching, deviceStatus: deviceCheck || '' })] }));
};
